import React, { createContext, useState, useContext } from 'react';

export const AccountStatusContext = createContext(null);

export const useAccountStatus = () => useContext(AccountStatusContext);

export const AccountStatusProvider = ({ children }) => {
  const [isAccountStatusPageActive, setIsAccountStatusPageActive] = useState(false);

  const value = {
    isAccountStatusPageActive,
    setIsAccountStatusPageActive,
  };

  return (
    <AccountStatusContext.Provider value={value}>
      {children}
    </AccountStatusContext.Provider>
  );
};
